/**
 * Shared formatting helpers. Used across every brand dashboard page —
 * keep them pure and side-effect-free so they work in both browser and
 * server-rendered contexts.
 */

/** Human-readable "how long ago" string from an ISO timestamp. */
export function timeAgo(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const sec = Math.max(0, (Date.now() - d.getTime()) / 1000);
  if (sec < 60) return 'just now';
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  if (sec < 86400 * 7) return `${Math.floor(sec / 86400)}d ago`;
  return d.toLocaleDateString();
}

/** Format an amount as money, falling back gracefully on bad currency codes. */
export function fmtMoney(amount, currency) {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${n.toFixed(2)} ${currency || ''}`.trim();
  }
}

/** Initials from a free-form name/email — used for avatars. */
export function initials(name) {
  if (!name) return '?';
  const parts = String(name).split(/[\s@._-]+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
  return String(name).slice(0, 2).toUpperCase();
}

/** Localized short date — used in tables. */
export function fmtDate(v) {
  if (!v) return '—';
  try { return new Date(v).toLocaleDateString(); } catch { return '—'; }
}

/** Localized date + time — used in detail panes. */
export function fmtDateTime(v) {
  if (!v) return '—';
  try { return new Date(v).toLocaleString(); } catch { return '—'; }
}
